import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import { FLOOR_PRICING_CONSTANTS } from '../../constants';
import GeneralSettings from './GeneralSettings';
import FloorEngineTypeSplit from './FloorEngineTypeSplit';
import GeneralTab from '../../../../Components/GeneralTabAndTabContent';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

const tabListAndPanels = [
	{
		tab: (
			<Tab
				label="General Settings"
				value={FLOOR_PRICING_CONSTANTS.PAGES.GENERAL}
				key={FLOOR_PRICING_CONSTANTS.PAGES.GENERAL}
			/>
		),
		tabPanel: (
			<TabPanel
				value={FLOOR_PRICING_CONSTANTS.PAGES.GENERAL}
				key={FLOOR_PRICING_CONSTANTS.PAGES.GENERAL}
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<GeneralSettings />
			</TabPanel>
		)
	},
	{
		tab: (
			<Tab
				label="Floor Engine Type Split"
				value={FLOOR_PRICING_CONSTANTS.PAGES.FLOOR_ENGINE_TYPE_SPLIT}
				key={FLOOR_PRICING_CONSTANTS.PAGES.FLOOR_ENGINE_TYPE_SPLIT}
			/>
		),
		tabPanel: (
			<TabPanel
				value={FLOOR_PRICING_CONSTANTS.PAGES.FLOOR_ENGINE_TYPE_SPLIT}
				key={FLOOR_PRICING_CONSTANTS.PAGES.FLOOR_ENGINE_TYPE_SPLIT}
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<FloorEngineTypeSplit />
			</TabPanel>
		)
	}
];

const SiteSettings = () => {
	return (
		<GeneralTab
			tabListAndPanels={tabListAndPanels}
			tabListStyles={{ width: 'fit-content', marginLeft: '3rem' }}
			system={SYSTEMS.BANNER_FP}
		/>
	);
};
export default SiteSettings;
